var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{staticClass:"ml-2",attrs:{"alt":"Ordo Logo","contain":"","src":'/img/' + _vm.logo,"height":38,"width":_vm.width}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }